<template>
  <div>
    <!-- Filters -->
    <app-collapse>
      <app-collapse-item :isVisible="true" title="Filters">
        <OkrListFilters
          :status-filter.sync="statusFilter"
          :status-options="okrStatusOption"
          :employee-filter.sync="employeeFilter"
          :employee-options.sync="employeeOptions"
          :manager-filter.sync="managerFilter"
          :manager-options="managerOptions"
          :month-filter.sync="monthFilter"
          :month-options="monthOptions"
          :year-filter.sync="yearFilter"
          :list-type.sync="listType"
          :completion-value.sync="completionValue"
        />
      </app-collapse-item>
    </app-collapse>
    <!-- Table Container Card -->
    <b-card no-body class="mb-0 mt-2">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-form-checkbox
              v-if="okrsMetaData.length && $can('Zircly Admin')"
              class="mr-2"
              v-model="isDeleteMultipleCandChecked"
            >
            </b-form-checkbox>
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              :searchable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div
              v-if="selectedOkrs.length == 0"
              class="d-flex align-items-center justify-content-end"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="SearchIcon" />
                </b-input-group-prepend>
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Search Name"
                />
              </b-input-group>
              <!-- <b-button
                v-if="$can('okr_show') && userDataLocal.user_okrs.length > 0"
                variant="primary"
                :to="{
                  path:
                    '/view/okr/' +
                    userDataLocal.user_okrs[userDataLocal.user_okrs.length - 1]
                      .hashid,
                }"
                class="mr-1"
              >
                <span class="text-nowrap">My OKRs</span>
              </b-button> -->
              <!-- <b-button
                v-if="$can('okr_create')"
                variant="primary"
                :to="{ name: 'add-okr' }"
              >
                <span class="text-nowrap">Add OKR</span>
              </b-button> -->
            </div>
            <b-button
              v-else-if="$can('okr_delete')"
              class="float-right"
              variant="danger"
              :disabled="okrsDeleteCount == 0"
              @click="confirmDeleteMultipleRecords"
            >
              <span class="text-nowrap">Delete {{ okrsDeleteCount }} OKR</span>
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-form-checkbox-group
        id="checkbox-group"
        v-model="selectedOkrs"
        name="selectedOkrs"
      >
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="fetchOkrList"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(select)="data">
            <div class="text-nowrap">
              <b-form-checkbox :value="data.item.hashid"> </b-form-checkbox>
            </div>
          </template>
          <!-- Column: User -->
          <template #cell(date_range)="data">
            <b-media vertical-align="center">
              <span
                v-b-tooltip.hover.topright.v-primary
                :title="data.item.date_range"
              >
                {{ data.item.date_range | str_limit(15) }}
              </span>
            </b-media>
          </template>

          <template #cell(user.name)="data">
            <b-media vertical-align="center" class="d-flex align-items-center">
              <template #aside>
                <b-avatar
                  size="32"
                  :src="data.item.user.avatar"
                  :text="avatarText(data.item.user.name)"
                />
              </template>
              <b-link
                v-if="$can('employee_show')"
                :to="{
                  name: 'view-employee',
                  params: { id: data.item.user.hashid },
                }"
                class="font-weight-bold d-inline-block text-nowrap"
                v-b-tooltip.hover.v-default
                :title="data.item.user.name"
              >
                {{ data.item.user.name | str_limit(15) }}
              </b-link>
              <span
                v-else
                class="d-block text-nowrap"
                v-b-tooltip.hover.v-default
                :title="data.item.user.name"
              >
                {{ data.item.user.name | str_limit(15) }}
              </span>
            </b-media>
          </template>

          <template #cell(manager.name)="data">
            <b-media vertical-align="center" class="d-flex align-items-center">
              <template #aside>
                <b-avatar
                  size="32"
                  :src="data.item.manager.avatar"
                  :text="avatarText(data.item.manager.name)"
                />
              </template>
              <b-link
                v-if="$can('employee_show')"
                :to="{
                  name: 'view-employee',
                  params: { id: data.item.manager.hashid },
                }"
                class="font-weight-bold d-inline-block text-nowrap"
                v-b-tooltip.hover.v-default
                :title="data.item.manager.name"
              >
                {{ data.item.manager.name | str_limit(15) }}
              </b-link>
              <span
                v-else
                class="d-block text-nowrap"
                v-b-tooltip.hover.v-default
                :title="data.item.manager.name"
              >
                {{ data.item.manager.name | str_limit(15) }}
              </span>
            </b-media>
          </template>
          <template #cell(progress)="data">
            <strong>{{ data.item.progress }}%</strong>
            <b-progress
              key="progress"
              animated
              variant="primary"
              class="'progress-bar-primary"
            >
              <b-progress-bar :value="data.item.progress" variant="primary">
              </b-progress-bar>
            </b-progress>
          </template>


          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              size="sm"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>

              <!-- <b-dropdown-item
                class="btn-sm p-0"
                @click="editRecord(data)"
                v-if="
                  ($can('Zircly Admin') || isCreator(data)) && $can('okr_edit')
                "
              >
                <feather-icon icon="EditIcon" size="13" class="mr-50" />
                <span>Edit</span>
              </b-dropdown-item>

              <b-dropdown-item
                class="btn-sm p-0"
                @click="viewRecord(data)"
                v-if="$can('okr_show')"
              >
                <feather-icon icon="EyeIcon" size="13" class="mr-50" />
                <span>View</span>
              </b-dropdown-item> -->

              <b-dropdown-item
                class="btn-sm p-0"
                @click="confirmDeleteRecord(data)"
                v-if="
                  ($can('Zircly Admin') || isCreator(data)) &&
                  $can('okr_delete')
                "
              >
                <feather-icon icon="TrashIcon" size="13" class="mr-50" />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-form-checkbox-group>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="
              d-flex
              align-items-center
              justify-content-center justify-content-sm-start
            "
          >
            <span class="text-muted"
              >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
              {{ dataMeta.of }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="
              d-flex
              align-items-center
              justify-content-center justify-content-sm-end
            "
          >
            <b-pagination
              v-if="selectedOkrs.length == 0"
              v-model="currentPage"
              :total-rows="totalOkrList"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
            <b-button
              v-else-if="$can('okr_delete')"
              class="float-right"
              variant="danger"
              :disabled="okrsDeleteCount == 0"
              @click="confirmDeleteMultipleRecords"
            >
              <span class="text-nowrap">Delete {{ okrsDeleteCount }} OKR</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BFormInput,
  BLink,
  BMedia,
  BPagination,
  BRow,
  BTable,
  VBTooltip,
  BFormCheckbox,
  BFormCheckboxGroup,
  BProgressBar,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { onUnmounted, watch, ref } from "@vue/composition-api";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import okrStoreModule from "../okrStoreModule";
import useOkrList from "./useOkrList";
import OkrListFilters from "./OkrListFilters.vue";
import { avatarText } from "@core/utils/filter";

export default {
  components: {
    OkrListFilters,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BLink,
    BPagination,
    AppCollapse,
    AppCollapseItem,
    vSelect,
    ToastificationContent,
    BFormCheckbox,
    BFormCheckboxGroup,
    BProgressBar,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  setup() {
    const REFERRAL_APP_STORE_MODULE_NAME = "app-okrs";
    const isDeleteMultipleCandChecked = ref(false);
    const selectedOkrs = ref([]);
    const okrsDeleteCount = ref(0);

    // Register module
    if (!store.hasModule(REFERRAL_APP_STORE_MODULE_NAME)) {
      store.registerModule(REFERRAL_APP_STORE_MODULE_NAME, okrStoreModule);
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(REFERRAL_APP_STORE_MODULE_NAME))
        store.unregisterModule(REFERRAL_APP_STORE_MODULE_NAME);
    });

    const statusOptions = [
      { label: "In Progress", code: 0 },
      { label: "Selected", code: 1 },
      { label: "Rejected", code: 2 },
    ];
    const {
      fetchOkrList,
      tableColumns,
      perPage,
      currentPage,
      totalOkrList,
      okrsMetaData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      statusFilter,
      filterByOkrUrgencyStatus,
      filterByOkrType,
      resolveUserStatusVariant,
      okrStatusOption,
      employeeFilter,
      managerFilter,
      monthFilter,
      yearFilter,
      listType,
      completionValue,
    } = useOkrList();

    watch(isDeleteMultipleCandChecked, (val) => {
      selectedOkrs.value = [];
      if (val) {
        okrsMetaData.value.forEach((okr) => {
          selectedOkrs.value.push(okr.hashid);
        });
      }
    });

    watch(selectedOkrs, (val) => {
      okrsDeleteCount.value = val.length;
    });

    return {
      // Sidebar
      fetchOkrList,
      tableColumns,
      perPage,
      currentPage,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      totalOkrList,
      // Extra Filters
      statusOptions,
      statusFilter,
      filterByOkrUrgencyStatus,
      filterByOkrType,
      selectedOkrs,
      okrsDeleteCount,
      isDeleteMultipleCandChecked,
      resolveUserStatusVariant,
      okrStatusOption,
      employeeFilter,
      managerFilter,
      monthFilter,
      yearFilter,
      listType,
      completionValue,
      avatarText,
      okrsMetaData,
    };
  },
  data() {
    return {
      employeeOptions: [],
      managerOptions: [],
      userDataLocal: this.$cookies.get("userData"),
      monthOptions: [
        {
          label: "January",
          code: "1",
        },
        {
          label: "February",
          code: "2",
        },
        {
          label: "March",
          code: "3",
        },
        {
          label: "April",
          code: "4",
        },
        {
          label: "May",
          code: "5",
        },
        {
          label: "June",
          code: "6",
        },
        {
          label: "July",
          code: "7",
        },
        {
          label: "August",
          code: "8",
        },
        {
          label: "September",
          code: "9",
        },
        {
          label: "October",
          code: "10",
        },
        {
          label: "November",
          code: "11",
        },
        {
          label: "December",
          code: "12",
        },
      ],
    };
  },
  created() {
    this.fetchEmployeesList();
    this.fetchManagerList();
    if (!this.$can("Zircly Admin")) {
      this.tableColumns = this.tableColumns.filter(
        (item) => item.key != "select"
      );
    }
  },
  methods: {
    fetchEmployeesList() {
      this.$store
        .dispatch("app/fetchEmployeeList")
        .then((res) => {
          this.employeeOptions = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    fetchManagerList() {
      this.$store
        .dispatch("app/fetchManagerList")
        .then((res) => {
          this.managerOptions = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    editRecord(data) {
      this.$router.push(`/edit/okr/${data.item.hashid}`).catch(() => {});
    },
    viewRecord(data) {
      this.$router.push(`/view/okr/${data.item.hashid}`).catch(() => {});
    },
    confirmDeleteRecord(data) {
      this.$swal({
        title: "Are you sure?",
        text: `You want to delete ${data.item.title}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRecord(data.item.hashid);
        }
      });
    },
    confirmDeleteMultipleRecords() {
      this.$swal({
        title: "Are you sure?",
        text: `You want to delete ${this.selectedOkrs.length} OKR(s), This cannot be undone.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("app-okrs/removeMultipleOkrs", this.selectedOkrs)
            .then((res) => {
              this.isDeleteMultipleCandChecked = false;
              this.selectedOkrs = [];
              if (res.data.success) {
                this.refetchData();
                // this.$toast({
                //   component: ToastificationContent,
                //   props: {
                //     title: "Deleted Successfully.",
                //     icon: "BellIcon",
                //     variant: "success",
                //     text: res.data.message,
                //   },
                // });
                this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Deleted Successfully.',
                icon: 'BellIcon',
                variant: 'success',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
              } else {
                // this.$toast({
                //   component: ToastificationContent,
                //   props: {
                //     title: "Okr Deletion failed.",
                //     icon: "BellIcon",
                //     variant: "danger",
                //     text: res.data.message,
                //   },
                // });
                this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Okr Deletion failed.',
                icon: 'BellIcon',
                variant: 'danger',
                text:  res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
              }
            })
            .catch((err) => console.log(err));
        }
      });
    },
    refetchOkrsData() {
      console.log("Added OKR");
    },
    isCreator(data) {
      if (data.item.user.hashid == this.userDataLocal.hashid) {
        return true;
      }
      return false;
    },
    deleteRecord(id) {
      const self = this;
      this.$store
        .dispatch("app-okrs/removeOkr", id)
        .then((res) => {
          if (res.status == "204") {
            // self.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "OKR Deleted",
            //     icon: "BellIcon",
            //     variant: "success",
            //     text: "OKR Deleted Successfully.",
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'OKR Deleted',
                icon: 'BellIcon',
                variant: 'success',
                text: "OKR Deleted Successfully.",
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
          } else {
            // self.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "OKR Deletion failed.",
            //     icon: "BellIcon",
            //     variant: "danger",
            //     text: res.data.message,
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'OKR Deletion failed.',
                icon: 'BellIcon',
                variant: 'danger',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
          }
          self.refetchData();
        })
        .catch((err) => {
          // self.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "OKR Deletion failed.",
          //     icon: "BellIcon",
          //     variant: "danger",
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: "OKR Deletion failed.",
                icon: 'BellIcon',
                variant: 'danger',
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"error-info ",
              hideProgressBar : true,
            });
          console.error(err);
        });
    },
    openWindow(link) {
      window.open(link);
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
